module.exports = __webpack_public_path__ + "static/media/FurtrieveLogo.0c9ba784.png";